import React, { ReactNode } from 'react';
import { Paper, Typography, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  card: {
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    padding: theme.spacing(2, 3),
    borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  },
  title: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  description: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  content: {
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'hidden',
    minHeight: 0,
  },
  footer: {
    padding: theme.spacing(2, 3),
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
}));

interface CardProps {
  className?: string;
  children?: ReactNode;
}

export const Card: React.FC<CardProps> = ({ className, children }) => {
  const classes = useStyles();
  return (
    <Paper className={classNames(classes.card, className)}>
      {children}
    </Paper>
  );
};

interface CardHeaderProps {
  className?: string;
  children?: ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ className, children }) => {
  const classes = useStyles();
  return <div className={classNames(classes.header, className)}>{children}</div>;
};

interface CardTitleProps {
  className?: string;
  children?: ReactNode;
}

export const CardTitle: React.FC<CardTitleProps> = ({ className, children }) => {
  const classes = useStyles();
  return (
    <Typography variant="h6" className={classNames(classes.title, className)}>
      {children}
    </Typography>
  );
};

interface CardDescriptionProps {
  className?: string;
  children?: ReactNode;
}

export const CardDescription: React.FC<CardDescriptionProps> = ({ className, children }) => {
  const classes = useStyles();
  return (
    <Typography variant="body2" className={classNames(classes.description, className)}>
      {children}
    </Typography>
  );
};

interface CardContentProps {
  className?: string;
  children?: ReactNode;
}

export const CardContent: React.FC<CardContentProps> = ({ className, children }) => {
  const classes = useStyles();
  return <div className={classNames(classes.content, className)}>{children}</div>;
};

interface CardFooterProps {
  className?: string;
  children?: ReactNode;
}

export const CardFooter: React.FC<CardFooterProps> = ({ className, children }) => {
  const classes = useStyles();
  return <div className={classNames(classes.footer, className)}>{children}</div>;
};

export default {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
  CardFooter,
};
